import { ServiceHttpError } from 'base/service_error';
import React from 'react';
import styles from './form.css';
import { TextRegularLight } from './typography';

export function InvisibleForm({
  children,
  loading,
  onSubmit,
  disabled,
}: {
  children: React.ReactNode;
  loading: boolean;
  onSubmit(): void;
  disabled?: boolean;
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (disabled) return;
        onSubmit();
      }}
      method="POST"
      className={styles.form}
    >
      <fieldset disabled={loading || disabled} className={styles.fieldset}>
        {children}
      </fieldset>
    </form>
  );
}

export function useSubmit<T extends any[]>(
  submit: (...args: T) => Promise<void>,
) {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<unknown | undefined>();

  const handleSubmit = React.useCallback(
    async (...args: T) => {
      if (loading) return;
      setLoading(true);
      setError(undefined);
      try {
        await submit(...args);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    },
    [loading, submit],
  );
  return [loading, error, handleSubmit] as const;
}

export function formatError(error: unknown): string {
  let message = `${error}`;
  if (error instanceof Error) {
    message = error.message;
  }
  if (error instanceof ServiceHttpError) {
    if (error.status >= 500 && error.status < 600) {
      message = `An error has occured. Please try again or contact support@relume.io if this error persists.  (code: ${error.requestId})`;
    }
    try {
      const body = JSON.parse(error.responseText);
      if (typeof body.detail === 'string') {
        message = body.detail;
      }
      if (typeof body.error === 'string') {
        message = body.error;
      }
    } catch (e) {
      // ignore
    }
  }
  return message;
}

export function RedErrorText({ error }: { error: unknown }) {
  if (error == null) return null;
  return <TextRegularLight color="red">{formatError(error)}</TextRegularLight>;
}
